module.exports = __webpack_public_path__ + "img/ladang-bt-13-1.9283bbb9.jpeg";